import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Landing from '../pages/Landing';
import Dashboard from '../pages/promoters/Dashboard';

const RootRedirect = () => {
  const { isAuthenticated, isVerified, isInVerificationProcess } = useSelector((state) => state.auth);

  // If not authenticated, show landing page
  if (!isAuthenticated) {
    return <Landing />;
  }

  // If authenticated but not verified or in verification process, redirect to verification
  if (!isVerified || isInVerificationProcess) {
    return <Navigate to="/verify-email" replace />;
  }

  // If authenticated and verified, show landing page with authenticated navbar
  return <Landing />;
};

export default RootRedirect;
